import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';

export class MessagesEndpoints {
  private env = inject<PIMSEnvironment>(ENVIRONMENT);
  private http = inject(HttpClient);

  put(messageId: number, payload: { read_at: string | null }) {
    return this.http.put(`${this.env.constants.ADMIN_API_URL}/admin/messages/${messageId}`, payload);
  }
}
